import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { withRouter } from 'react-router-dom'
import SvgIcon from 'src/components/SvgIcon'
import Icon from 'src/components/Icon'
import { logError, isEmpty } from 'src/utils/helpers'

import 'src/theme/animation.less'
import styles from './List.module.less'

class List extends PureComponent {
  constructor(props) {
    super(props)

    this.isScrolledToItem = false
    this.listRefs = []
  }

  static contextTypes = {
    router: PropTypes.object
  }

  static defaultProps = {
    preventActiveState: false,
  }

  goTo = (item) => (e) => {
    e.preventDefault()
    const {
      onClick,
      history,
      isMainMenu,
      setCurrentlyOpenFeature,
      closeSidebar,
      areAppActionsDisabled,
    } = this.props

    if (areAppActionsDisabled === true) {
      return false
    }

    if (isMainMenu && typeof setCurrentlyOpenFeature === 'function') {
      setCurrentlyOpenFeature(item.feature)
    }

    if (typeof closeSidebar === 'function') {
      closeSidebar()
    }

    if (typeof onClick === 'function') {
      onClick(item)
    }

    if (item.hasOwnProperty('url') && item.url) {
      if (item.url.startsWith('http')) {
        window.open(item.url, '_blank');
      } else {
        history.push({
          pathname: item.url,
          state: {
            listItem: item,
          }
        })
        return true
      }
    }
  }

  renderCheckbox = (type) => {
    if (type === 'Checked') {
      return <div className={styles.checked + " kiosk-color-primary--border-color kiosk-color-primary--background"}>
        <Icon
          type="check"
          theme="outlined"
          style={{ fontSize: '20px', color: '#fff' }}
        />
      </div>
    } else {
      return <div className={styles.unchecked + " kiosk-color-primary--border-color"} />
    }
  }

  renderLeftIcon = (type) => {
    const { styleVariation, styleVariationDesktop, classNameLeftIconSvg } = this.props

    if(type === 'auto') {
      type = 'Vehicle'
    }

    if (type === 'Checked' || type === 'CheckedNo') {
      return this.renderCheckbox(type)
    } else {
      const classNames = cx({
        [classNameLeftIconSvg]: !!classNameLeftIconSvg,
        [styles.leftIconSvg]: true,
        [styles.leftIconSvgDesktopBlocks]: styleVariationDesktop && styleVariationDesktop === 'blocks',
        'kiosk-color--primary-color': styleVariation && styleVariation === 'checklist',
      })
      return <SvgIcon className={classNames} size={'md'} type={type} />
    }
  }

  /**
   * Collect all list item refs in an array.
   *
   * @param refKey Array key by which we can later find a specific ref.
   * @param ref Actual react ref
   */
  updateRefs = (refKey, ref) => {
    this.listRefs[refKey] = ref
  }

  /**
   * Try to find list item ref.
   *
   * @param refKey
   * @return {null|*}
   */
  getListRef = (refKey) => {
    try {
      if (this.listRefs && this.listRefs.hasOwnProperty(refKey)) {
        return this.listRefs[refKey]
      }
      return null
    } catch (e) {
      return null
    }
  }

  /**
   * Scroll to ref element so that it's centered vertically in the middle of the screen.
   *
   * @param refKey
   * @return {boolean}
   */
  scrollTo = (refKey) => {
    try {
      const ref = this.getListRef(refKey)
      if (ref) {
        ref.scrollIntoView({
          behavior: "smooth", block: "center",
        })

        return true
      }
      return false
    } catch (e) {
      logError('Scroll to list item', e, 0)
      return false
    }
  }

  renderItems = (items) => {

    const {
      currentlyOpenFeature,
      isMainMenu,
      classNameListItem,
      classNameListItemText,
      classNameListItemName,
      classNameListItemDescription,
      preventActiveState,
    } = this.props

    this.isScrolledToItem = false

    return items.map((item, itemKey) => {
      
      const isActive = isMainMenu && item.feature === currentlyOpenFeature && !preventActiveState

      const error = item && item.hasOwnProperty('errorMessage') && !isEmpty(item.errorMessage) ? item.errorMessage : null

      // Try to scroll to the item if there is an error and we didn't already scrolled to some other item
      if (!!error && !this.isScrolledToItem) {
        this.isScrolledToItem = this.scrollTo(itemKey)
      }

      const listItemClassNames = cx({
        [classNameListItem]: !!classNameListItem,
        [styles.listItem]: true,
        [styles.listItemActive]: isActive,
        // Overwritten in colors.less
        'kiosk-color-list-item-active': isActive,
      })

      const listItemTextClassNames = cx({
        [classNameListItemText]: !!classNameListItemText,
        [styles.listItemText]: true,
      })

      const listItemNameClassNames = cx({
        [classNameListItemName]: !!classNameListItemName,
        [styles.listItemName]: true,
      })

      const listItemDescriptionClassNames = cx({
        [classNameListItemDescription]: !!classNameListItemDescription,
        [styles.listItemDescription]: true,
        [styles.listItemDescriptionError]: !!error,
      })

      return (
        <li
          ref={(ref) => this.updateRefs(itemKey, ref)}
          key={itemKey}
          data-cy={item.feature}
          className={listItemClassNames}
          onClick={this.goTo(item)}
        >
          <div display-if={item.iconUrl} className={styles.listItemIconHolder}>
            <img src={item.iconUrl} alt="Icon" className={styles.listItemIcon} />
          </div>
          <div display-if={item.leftIcon} className={styles.listItemIcon + (isMainMenu ? ' ' + styles.listItemIconMainMenu : '')}>
            {this.renderLeftIcon(item.leftIcon)}
          </div>
          <div display-if={item.customContentLeft} className={styles.customContentLeft}>
            {item.customContentLeft}
          </div>
          <div className={listItemTextClassNames}>
            {item.hasOwnProperty('topInfo') && item.topInfo ? (
              <div className={styles.listItemTopInfo}>
                {item.topInfo}
              </div>
            ) : ''}
            <div className={listItemNameClassNames}>
              {item.name}
            </div>
            <div className={listItemDescriptionClassNames}>
              {error ? error : item.description}
            </div>
          </div>
          {item.hasOwnProperty('rightCheckbox') && item.rightCheckbox ? (
            <div className={styles.listItemIcon + ' ' + styles.rightCheckbox}>
              {this.renderCheckbox(item.rightCheckbox)}
            </div>
          ) : ''}
          <div display-if={item.rightIcon} className={styles.listItemIcon + ' ' + styles.listItemRightIcon}>
            <SvgIcon size={'xs'} type={'right_arrow'} />
          </div>
          <div display-if={item.customContentRight} className={styles.customContentRight}>
            {item.customContentRight}
          </div>
        </li>
      )
    })
  }

  render() {
    const { className, styleVariationDesktop, styleVariation, textsWhiteSpace, attrDataQa, items, noResultsMessage } = this.props

    if((noResultsMessage && noResultsMessage.length > 0) && !(items && items.length > 0)) {
      return (
        <h3 className={styles.noResults}>
          {noResultsMessage}
        </h3>
      )
    }

    const classNames = cx({
      [className]: !!className,
      [styles.list]: true,
      [styles.listStyleDesktopBlocks]: styleVariationDesktop && styleVariationDesktop === 'blocks',
      [styles.listStyleChecklist]: styleVariation && styleVariation === 'checklist',
      [styles.textsWhiteSpaceWrap]: textsWhiteSpace && textsWhiteSpace === 'wrap',
    })

    return (
      <ul className={classNames} style={this.props.style} data-qa={attrDataQa || 'list-undefined'}>
        { this.renderItems(items) }
      </ul>
    )
  }
}

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    // Main title
    name: PropTypes.string,
    // Text above main title
    topInfo: PropTypes.string,
    // Text below main title
    description: PropTypes.string,
    // When used for main menu
    feature: PropTypes.string,
    // When used as SvgIcon type
    leftIcon: PropTypes.string,
    // For replacing whole left icon content
    // customContentLeft: PropTypes.elementType,
    // Element to render on the right side
    // customContentRight: PropTypes.elementType,
    // e.g. 'Checked'
    rightCheckbox: PropTypes.string,
    // Right arrow (carousel)
    rightIcon: PropTypes.string,
    // URL to open when clicked on item
    url: PropTypes.string,
    // For marking list item as required
    errorMessage: PropTypes.string,
  })).isRequired,
}

export default withRouter(List)
